"use strict";
var Observable_1 = require('../../Observable');
var scan_1 = require('../../operator/scan');
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/rxjs/add/operator/scan.js
// module id = ../../../../rxjs/add/operator/scan.js
// module chunks = 4